import type { CompletedDealItem } from '../types/mapping';
import { MobileListItem } from './item/mobile-list-item';

type Props = {
  items: CompletedDealItem[];
  className?: string;
};

export function MobileList({ items, className }: Props) {
  return (
    <ul className={className}>
      {items.map((item, index) => (
        <MobileListItem key={index} item={item} />
      ))}
    </ul>
  );
}
